import React from 'react';
import Toast from '@ingka/toast';
import ToastText from '@ingka/toast';
import createZState from 'zustand';
import skapaToken from '@ingka/variables';

type ToastState = {
  isVisible: boolean;
  close: () => void;
  open: (message: string, type: ToastState['messageType']) => void;
  message: string;
  messageType: 'INFO' | 'ERROR';
};

export const useToast = createZState<ToastState>((set) => ({
  isVisible: false,
  message: '',
  messageType: 'INFO',
  close: () => set((s) => ({ ...s, isVisible: false })),
  open: (message, type) => set((s) => ({ message, isVisible: true, messageType: type })),
}));

export const ToastAnchor = () => {
  const toast = useToast();
  const bgColor: { [k in ToastState['messageType']]: string } = {
    INFO: skapaToken.colourSemanticPositive,
    ERROR: skapaToken.colourSemanticNegative,
  };

  return (
    <Toast
      style={{
        backgroundColor: bgColor[toast.messageType],
        borderColor: bgColor[toast.messageType],
      }}
      text={toast.message}
      isOpen={toast.isVisible}
      onCloseRequest={() => toast.close()}
      ariaLabelCloseBtn="Dismiss notification"
    />
  );
};
